import { Injectable } from '@angular/core';
import { ImageApiService } from './image-api.service';
import { ImageAsset } from './image-asset-model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ImageManagerService
{
    constructor(private imageApiService: ImageApiService)
    {}

    private static dataURLToBlob(dataURL)
    {
        const BASE64_MARKER = ';base64,';
        if (dataURL.indexOf(BASE64_MARKER) === -1)
        {
            const parts2 = dataURL.split(',');
            const contentType2 = parts2[ 0 ].split(':')[ 1 ];
            const raw2 = parts2[ 1 ];

            return new Blob([ raw2 ], { type: contentType2 });
        }

        const parts = dataURL.split(BASE64_MARKER);
        const contentType = parts[ 0 ].split(':')[ 1 ];
        const raw = window.atob(parts[ 1 ]);
        const rawLength = raw.length;

        const uInt8Array = new Uint8Array(rawLength);

        for (let i = 0; i < rawLength; ++i)
        {
            uInt8Array[ i ] = raw.charCodeAt(i);
        }

        return new Blob([ uInt8Array ], { type: contentType });
    }

    downloadImageAsset(imageAsset: ImageAsset): Observable<boolean>
    {
        return this.imageApiService.downloadImageAsset(imageAsset);
    }

    getImageWithSize(imageId: number, width: number, height: number)
    {
        return this.imageApiService.getImageWithSize(imageId, width, height);
    }
}
